import React, { useMemo } from "react";
import { Badge } from "evergreen-ui";

const StatusBadge = ({ status }) => {
  const badgeColor = useMemo(() => {
    switch (status) {
      case "opened":
      case "processing-automatic":
      case "processing-manual":
        return "neutral";
      case "on_question":
      case "submitted":
        return "blue";
      case "approved":
      case "paid":
        return "green";
      case "rejected":
        return "red";
      default:
        return "neutral";
    }
  }, [status]);

  const badgeLabel = useMemo(() => {
    switch (status) {
      case "opened":
      case "processing-automatic":
      case "processing-manual":
        return "Processing";
      case "on_question":
      case "submitted":
        return "Pending Approval";
      case "approved":
        return "Approved";
      case "rejected":
        return "Declined";
      default:
        return status || "-";
    }
  }, [status]);

  return (
    <Badge appearance="solid" color={badgeColor}>
      {badgeLabel}
    </Badge>
  );
};

export default StatusBadge;
